import { NavigateFunction } from "react-router-dom";
import { Hit } from "../../../../data-model/algoliaSearchModel";
import { ScreenNamesForBigQuery } from "../../../../enums/eventsData";
import { EventsName } from "../../../../enums/eventsName";
import { getOrgIdForFetchExternalWorklist } from "../../../../utils/organizationHelper";
import { apiWorkerManager } from "../../../../workerManagers/workerManager";

export const handleNavigateToNextScreenFromMyPaTable = (
  rowData: any,
  userId: string,
  userEmail: string,
  tabId: string,
  navigate: NavigateFunction,
) => {
  const data = JSON.parse(rowData.rowData as string) as Hit;
  apiWorkerManager.enqueueAndProcess({
    patient_id: data?.patient_id ?? "",
    org_id: getOrgIdForFetchExternalWorklist(),
    order_id: rowData.id,
    event_name: EventsName.ORDER_CLICKED,
    user_id: userId ?? "",
    user_email: userEmail ?? "",
    additional_data: {
      screen_name: ScreenNamesForBigQuery.WORKLIST,
      source: tabId ?? "",
    },
  });
  navigate(`/worklists/evbv/${rowData["id"]}`);
};
